import useQueryParams from './useQueryParams'

export const useCloseEnquiry = (): string | null => {
  const searchParams = useQueryParams()
  const closeEnquiry = searchParams.get('closeEnquiry')
  return closeEnquiry
}
